export default __webpack_public_path__ + "static/young-chef-olympiad-6780b2f282c23feab3888958cb9acdc7.png";